<template>
  <div :class="{'mobile-open': $sidebar.toggleSidebar}">
    <div :class="{'nav-open': $sidebar.showSidebar == 'opened' ? true : false, 'nav-reduced': $sidebar.showSidebar == 'reduced' ? true : false, 'nav-closed': $sidebar.showSidebar == 'closed' ? true : false, 'nav-closed-reduced': $sidebar.showSidebar == 'closed_reduced' ? true : false, 'is-dashboard-route': isDashboardRoute}">
      <loading :active.sync="isLoading" loader="dots" :is-full-page="true" color="#2E9E4F"></loading>
      <!-- 👇 AÑADE ESTO -->
      <notifications group="app" position="top right" />
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
  import Loading from 'vue-loading-overlay';
  import { mapGetters } from 'vuex';
  export default {
         components: {
            Loading
        },
        computed: {
            ...mapGetters({
                isLoading: 'isLoading'
            }),
            // $sidebar.showSidebar tiene un valor por defecto ('opened')
            // independiente de la ruta, así que en /login la clase nav-open
            // (o la que sea) está igualmente presente aunque ahí no exista
            // ningún sidebar real. Esta clase adicional distingue si de
            // verdad estamos dentro del layout del dashboard (el único sitio
            // donde tiene sentido desplazar el overlay de carga para dejar
            // hueco al sidebar).
            isDashboardRoute () {
                return this.$route.path !== '/login' && this.$route.path !== '/recovery';
            }
        }
  }
</script>
<style lang="scss">
  .vue-notifyjs.notifications{
    .list-move {
      transition: transform 0.3s, opacity 0.4s;
    }
    .list-item {
      display: inline-block;
      margin-right: 10px;

    }
    .list-enter-active {
      transition: transform 0.2s ease-in, opacity 0.4s ease-in;
    }
    .list-leave-active {
      transition: transform 1s ease-out, opacity 0.4s ease-out;
    }

    .list-enter {
      opacity: 0;
      transform: scale(1.1);

    }
    .list-leave-to {
      opacity: 0;
      transform: scale(1.2, 0.7);
    }
  }
  ul.error-list{
      list-style-type: disc;
  }
  .text-sm{
    font-size: 85%;
  }

  // El overlay de carga (puntos verdes) es "is-full-page", así que por
  // defecto se centra en toda la ventana, incluido el sidebar. Se desplaza
  // para que quede centrado solo en la zona de contenido de la derecha,
  // descontando el ancho real del sidebar según su estado. El ".is-dashboard-route"
  // es imprescindible: $sidebar.showSidebar (y por tanto nav-open/nav-reduced/
  // etc.) tiene un valor por defecto independiente de la ruta, así que sin
  // esta comprobación estas reglas también se aplicaban en /login (donde no
  // existe ningún sidebar real), dejando sin cubrir con el velo la franja
  // izquierda donde "debería" estar.
  .is-dashboard-route.nav-open .vld-overlay.is-full-page {
    left: 260px !important;
    width: calc(100% - 260px) !important;
  }
  .is-dashboard-route.nav-reduced .vld-overlay.is-full-page,
  .is-dashboard-route.nav-closed-reduced .vld-overlay.is-full-page {
    left: 72px !important;
    width: calc(100% - 72px) !important;
  }
  // En tablet/móvil el sidebar es siempre el riel de 72px, sea cual sea su
  // estado (ver SideBar.vue), así que el overlay se desplaza igual en los
  // tres casos.
  @media (max-width: 991.98px) {
    .is-dashboard-route.nav-open .vld-overlay.is-full-page,
    .is-dashboard-route.nav-reduced .vld-overlay.is-full-page,
    .is-dashboard-route.nav-closed-reduced .vld-overlay.is-full-page {
      left: 72px !important;
      width: calc(100% - 72px) !important;
    }
  }
</style>
